

























import { Component, Vue, Prop, Mixins, Ref } from 'vue-property-decorator'
import widgetCommon from './widgetCommon'
import editor from '@/components/editor/index.vue'
import { emitter } from '@/utils/mmit';
import {uuid} from '@/utils/common';

@Component({
  components: {
    editor
  }
})
export default class extends Mixins(widgetCommon) {
  @Ref() public editor!: editor
  private isEdit = false
  private get rules () {
    return this.commonRule
  }
  public mounted() {
    emitter.on('changeRichText', this.changeRichText);
  }
  public beforeDestroy() {
    emitter.off('changeRichText', this.changeRichText);
  }
  public initField () {
    this.editor.initData(this.form[this.item.businessId])
  }
  private changeState (e) {
    if (e.target.tagName === 'A') {
      return
    }
    if (this.disabled) {
      return
    }
    this.isEdit = true
  }
  private keyFun (type) {
    return `${this.item.companyId}/richtext/${this.item.worksheetId}/${uuid()}.` + type
  }
  private changeRichText(fieldBusinessId) {
    if (fieldBusinessId === this.item.businessId) {
      this.editor.initData(this.form[this.item.businessId])
    }
  }
}
